<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState" :title="modalTitle"
                    @onCommand="toolbarCommand" showBlock></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>
            <v-flex xs3>
               <v-card flat style="border-radius: 8px; margin-top: -8px;">
                  <v-img :aspect-ratio="idRatio" :src="media" style="border-radius: 8px"></v-img>

                  <v-toolbar flat>
                     <v-spacer></v-spacer>

                     <v-tooltip bottom>
                        <v-btn @click.stop="loadImgClick" color="primary" dark fab
                               slot="activator" small>
                           <v-icon small>fas fa-camera</v-icon>
                        </v-btn>
                        Carregar Imagem (min. 250px por 250px)
                     </v-tooltip>

                     <v-spacer></v-spacer>
                  </v-toolbar>

               </v-card>
            </v-flex>

            <v-flex xs9>
               <v-layout row wrap>
                  <a-text-field autofocus label="Nome da Empresa"
                                text-transform="capitalize" v-model="formData.name"
                                validate="required"></a-text-field>

                  <a-text-field label="CNPJ/CPF" sm6
                                v-mask="['##.###.###/####-##', '###.###.###-##']" v-model="formData.federalId"
                                validate="required"></a-text-field>
                  <a-select-field label="Fuso Horário" obj="timeZoneNames" sm6
                                  v-model="formData.timeZoneId"></a-select-field>
                  <a-text-field label="Fone" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.phone"
                                validate="required"></a-text-field>
                  <a-text-field label="WhatsApp" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.whatsapp"></a-text-field>
               </v-layout>
            </v-flex>

            <a-text-field label="Email" md6 v-model="formData.email" validate="email"></a-text-field>
            <a-text-field label="ID externo do parceiro" md6 v-model="formData.externalKey"></a-text-field>
            <a-text-field label="CEP" mask="##.###-###" md3 v-model="formData.zipcode"></a-text-field>
            <a-text-field label="Cidade" md6 text-transform="capitalize" v-model="formData.city"></a-text-field>
            <a-text-field label="Estado" md3 text-transform="uppercase" v-model="formData.state"></a-text-field>
            <a-text-field label="Endereço" text-transform="capitalize" v-model="formData.address"></a-text-field>

         </v-layout>

         <template slot="rightContent">
            <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat style="border-radius: 12px; margin-top: -10px">
               <v-toolbar color="rgba(0,0,0, 0.03)" dense flat>
                  <v-toolbar-title>Usuário Gestor</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn @click="copyUser" flat icon small>
                     <v-icon small>far fa-copy</v-icon>
                  </v-btn>
               </v-toolbar>
               <v-layout pt-4 pb-2 px-3 row wrap>
                  <a-text-field label="Celular" sm4 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.mobileNumber"></a-text-field>

                  <a-text-field label="Usuário" sm4 v-model="formData.loginName"></a-text-field>

                  <a-text-field hint="(para primeiro acesso)" label="Senha Temporária" sm4
                                v-model="formData.firstPin"></a-text-field>
               </v-layout>
            </v-card>
            <v-card flat color="rgba(0,0,0, 0.03)" style="border-radius: 12px; margin-top: -10px">
               <v-card-title class="pb-1 title text-truncate text-no-wrap" primary-title>
                  Usuários Contratados
               </v-card-title>
               <v-card-text class="pt-0">
                  A quantidade de usuários contratados representa o volume de <b>acessos simultâneos</b> que possui para
                  todos que precisam utilizar o sistema (gestores, operadores, etc.).
               </v-card-text>
               <v-container pa-0>
                  <v-layout row wrap>
                     <v-flex style="text-align: center" xs4>
                        <label class="biggerNumber text-center">{{formData.maxPaQty}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8>
                        <v-btn @click="buyMore" color="primary" dark>Comprar Acessos</v-btn>
                     </v-flex>
                     <v-flex xs12>
                        <v-divider></v-divider>
                     </v-flex>
                     <v-flex style="text-align: center" xs4>
                        <label class="bigNumber text-center">{{formData.qtyUsers}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8>
                        <v-label class="text-primary">Usuários Cadastrados</v-label>
                     </v-flex>
                     <v-flex xs12 v-if="!formData.partner">
                        <v-divider inset></v-divider>
                     </v-flex>
                     <v-flex style="text-align: center" xs4 v-if="!formData.partner">
                        <label class="bigNumber text-center">{{formData.qtyPartners}}</label>
                     </v-flex>
                     <v-flex align-self-center xs8 v-if="!formData.partner">
                        <v-label class="text-primary">Parceiros Cadastrados</v-label>
                     </v-flex>
                  </v-layout>
               </v-container>
            </v-card>
         </template>

      </crud-form>

   </div>


</template>

<script>
   let cbTemplate = `
      Seu usuário no Consigmais é: *{0}*
      e sua senha temporária é: *{1}*.
      Lembre-se de altera-la em seu próximo acesso a https://app.consigmais.com.br
   `;

    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

   export default CrudFormClass.extend({
      name: 'PartnerForm',

      data: function () {
         return {
            title: 'Parceiro',
            formName: 'partnerForm',

            formData: {
               id: null,
               name: null,
               logo: null,
               address: null,
               city: null,
               state: null,
               zipcode: null,
               federalId: null,
               phone: null,
               whatsapp: null,
               email: null,
               timeZoneId: 'America/Sao_Paulo',
               notes: null,
               partner: 1,
               paQty: 1,
               maxPaQty: 0,
               qtyUsers: 0,
               qtyPartners: 0,
               blocked: 0,
               pasLeft: 0,
               dummyPartner: false,
               managerId: null,
               loginName: null,
               firstPin: null,
               mobileNumber: null,
               externalKey: null
            }
         };
      },

      computed: {
         idRatio () {
            let mediaRatio = 1;
            return mediaRatio;
         },

         media () {
            let media = '/static/images/empty-logo.jpg';

            if (this.formData.logo) {
               media = this.$config.imageUri(this.formData.logo, 'logo');
            }

            return media;
         }
      },

      methods: {
         afterSave (data) {
            console.log(data);
            if (!this.newState) {
               this.formData.pasLeft = data.pasLeft;
               this.formData.managerId = data.managerId;
               this.formData.companyId = data.companyId;
            }
         },

         loadImgClick () {
            window.cloudinary.openUploadWidget(window.cloudinaryOptions.logos, this.uploadedMedia);
         },

         uploadedMedia (error, result) {
            if (result && result.length) {
               this.formData.logo = result[0].path;
            }
         },

         buyMore () {
            this.$notifyUser({
               type: 'info',
               message: `Favor ligar para (84) 99999-9999 para efetivar a contratação.`
            });
         },

         copyUser () {
            window.Clipboard.copy(cbTemplate.format(this.formData.loginName, this.formData.firstPin));
            this.$notifyUser({
               type: 'info',
               message: `Usuário gestor copiado para área de transferência`,
               position: 'top right'
            });
         }
      }
   });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
   }

</style>



// WEBPACK FOOTER //
// src/pages/PartnerForm.vue